import React, { useState } from "react";
import { Button, Card } from "react-bootstrap";
import { getCategoriesView } from "../../components/helper";
import { getProducts } from "../../helper";
import AWS_CONSTANTS from "../../constants/aws";
import Lightbox from "react-image-lightbox";
import "./styles.scss";

export default function ImageGallery(props) {
  const [products, setImageGalleryProducts] = useState([]);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [showGallery, setShowGallery] = useState(false);
  const { isMobile, categories } = props;

  const getCategoriesColumns = (
    categories,
    startIndex,
    endIndex,
    handleOnClick
  ) => {
    let retval = [];
    for (let i = startIndex; i <= endIndex; i++) {
      retval.push(
        <div className="mt-2 mb-2" key={categories[i]["category_id"]}>
          <Card
            key={categories[i]["category_id"]}
            style={{
              borderWidth: "3px",
              borderColor: "#ac8d30",
              borderRadius: "1rem",
              borderStyle: "solid",
              marginLeft: i === startIndex ? "0.5vw" : "1vw",
              marginRight: isMobile ? "1vw" : "0",
            }}
            className="h-100"
          >
            <Card.Img
              className="card-image"
              variant="top"
              src={`${AWS_CONSTANTS.ASSETS_URL}${categories[i]["image_src"]}`}
              style={{
                borderTopRightRadius: "0.80rem",
                borderTopLeftRadius: "0.80rem",
              }}
            />

            <Card.Body>
              <Card.Title>{categories[i]["category_name"]}</Card.Title>
              <hr style={{ borderColor: "#ac8d30" }} />
              <Card.Text>{categories[i]["category_description"]}</Card.Text>
            </Card.Body>
            <Button
              variant="outline-warning"
              className="mb-4 mx-auto landing-button"
              style={{ width: "65%" }}
              onClick={async () => {
                getProducts({
                  categoryId: categories[i].category_id,
                  imageGallery: true,
                }).then((result) => {
                  setImageGalleryProducts(result.products || []);
                  setPhotoIndex(0);
                  setShowGallery(true);
                });
              }}
            >
              VIEW PRODUCTS
            </Button>
          </Card>
        </div>
      );
    }
    return retval;
  };

  return (
    <>
      <div className="heading text-center mt-2">
        <h2 className="text-capitalize">Image Gallery</h2>
      </div>
      <div className="pb-5">
        {getCategoriesView(categories, getCategoriesColumns, () => {}, {
          xs: 1,
          sm: 1,
          md: 4,
          lg: 4,
        })}
      </div>
      {showGallery && products.length > 0 && (
        <Lightbox
          imagePadding={isMobile ? 40 : 10}
          mainSrc={`${AWS_CONSTANTS.ASSETS_URL}${products[photoIndex].image_src}`}
          nextSrc={`${AWS_CONSTANTS.ASSETS_URL}${
            products[(photoIndex + 1) % products.length].image_src
          }`}
          prevSrc={`${AWS_CONSTANTS.ASSETS_URL}${
            products[(photoIndex + products.length - 1) % products.length]
              .image_src
          }`}
          onCloseRequest={() => setShowGallery(false)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + products.length - 1) % products.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % products.length)
          }
          imageTitle={products[photoIndex].product_name}
          imageCaption={products[photoIndex].product_desc}
        />
      )}
    </>
  );
}
